import JoinTeamModal from './JoinTeamModal';

export default JoinTeamModal;
